import get from 'lodash/get';
import { a as ProductType } from '../product-_pRduMz7.js';

const isCategoryExcludedFromSale = (id, categoriesExcludeList) => categoriesExcludeList.indexOf(id) !== -1;
const isProductExcludedFromSale = (sku, productsExcludeList) => productsExcludeList.indexOf(sku) !== -1;
const getProductDiscount = (discount, product, productsExludeList) => {
    const isExcluded = isProductExcludedFromSale(product.sku, productsExludeList);
    // Do not show SaleFlag if the product is excluded from sales
    if (isExcluded)
        return '';
    // Manual "discount" should always override dynamic discount
    if (discount)
        return discount;
    // Calculate product discount
    // TODO: it's better to get a ready prop from the BE side instead of using a FE formula calculations
    let oldPrice = 0;
    let newPrice = 0;
    if (product.type_id === ProductType.Configurable) {
        // For Configurable product get the price values of the first variant
        // Considering that all variants has the same discount difference coefficient
        oldPrice = get(product, ['variants', 0, 'product', 'price_range', 'minimum_price', 'regular_price', 'value'], 0);
        newPrice = get(product, ['variants', 0, 'product', 'price_range', 'minimum_price', 'final_price', 'value'], 0);
    }
    else {
        oldPrice = get(product, 'price_range.minimum_price.regular_price.value', 0);
        newPrice = get(product, 'price_range.minimum_price.final_price.value', 0);
    }
    if (oldPrice === 0)
        return '';
    const priceDifference = oldPrice - newPrice;
    if (priceDifference === 0)
        return '';
    const discountPercentage = (priceDifference / oldPrice) * 100;
    // Do not display if value is below 5%
    if (discountPercentage < 5)
        return '';
    const roundedDiscountPercentage = Math.round(discountPercentage);
    return `-${roundedDiscountPercentage}%`;
};
const getCategoryDiscount = (discount, categoryId, categoriesExludeList) => {
    const isExcluded = isCategoryExcludedFromSale(categoryId, categoriesExludeList);
    // Do not show SaleFlag if the category is excluded from sales
    if (isExcluded)
        return '';
    // Manual "discount" should always override dynamic discount
    if (discount)
        return discount;
    // TODO: implement category discount when the BE will be ready
    return '';
};

export { getCategoryDiscount, getProductDiscount };
//# sourceMappingURL=saleFlag.js.map
